import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import useNavigator from "@saleor/hooks/useNavigator";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { chooseAccountPath, userLoginPath } from "./../../urls";

const useStyles = makeStyles(
  theme => ({
    actionWrapper: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end"
    },
    errorText: {
      color: "#FFFFFF"
    },
    loginReset: {
      "&:hover": {
        cursor: "pointer"
      },
      color: theme.palette.primary.main,
      textDecoration: "none"
    },
    panel: {
      "& .MuiAlert-icon": {},
      "& .MuiPaper-root": {
        "& .MuiTypography-caption": {
          fontSize: "0.875rem"
        },
        background: "#B20B0B",
        borderRadius: 0,
        color: "#FFFFFF"
      },
      background: "#B20B0B",
      borderRadius: 0,
      left: 0,
      marginBottom: theme.spacing(3),
      marginTop: "-40px",
      padding: "10px 15px",
      position: "absolute",
      right: 0,
      top: 0
    },
    submit: {
      marginLeft: "1rem",
      width: "50%"
    }
  }),
  {
    name: "ResetPasswordPage"
  }
);

export interface ResetPasswordPageFormData {
  email: string;
}
export interface ResetPasswordPageProps {
  disabled: boolean;
  error: string;
  onSubmit: (data: ResetPasswordPageFormData) => void;
}

const ResetPasswordPage: React.FC<ResetPasswordPageProps> = props => {
  const { disabled, error, onSubmit } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const { savedAccounts } = useSavedAccount();
  const navigate = useNavigator();

  const handleLoginNavigation = () => {
    if (savedAccounts.length) {
      navigate(chooseAccountPath);
    } else {
      navigate(userLoginPath);
    }
  };

  return (
    <Form initial={{ email: "" }} onSubmit={onSubmit}>
      {({ change: handleChange, data, submit: handleSubmit }) => (
        <>
          {!!error && (
            <div className={classes.panel}>
              <Typography variant="caption" className={classes.errorText}>
                {error}
              </Typography>
            </div>
          )}
          <Typography>
            <FormattedMessage defaultMessage="Forgot your password? Don't worry, we'll reset it for you." />
          </Typography>
          <FormSpacer />
          <TextField
            autoFocus
            disabled={disabled}
            fullWidth
            autoComplete="username"
            label={intl.formatMessage(commonMessages.email)}
            name="email"
            onChange={handleChange}
            value={data.email}
            inputProps={{
              "data-test": "email"
            }}
          />
          <FormSpacer />
          <div className={classes.actionWrapper}>
            <Typography
              className={classes.loginReset}
              component="a"
              onClick={handleLoginNavigation}
            >
              Login
            </Typography>
            <Button
              className={classes.submit}
              color="primary"
              disabled={disabled}
              variant="contained"
              onClick={handleSubmit}
              type="submit"
            >
              <FormattedMessage
                defaultMessage="Submit"
                description="password reset, button"
              />
            </Button>
          </div>
        </>
      )}
    </Form>
  );
};

ResetPasswordPage.displayName = "ResetPasswordPage";
export default ResetPasswordPage;
